// removed by extract-text-webpack-plugin
module.exports = {"container":"CallGraphsComponent-container","pane":"CallGraphsComponent-pane","iframeContainer":"CallGraphsComponent-iframeContainer"};